import domReady from '@wordpress/dom-ready';

/**
 * Handles the click event on a live entry link.
 *
 * Tries to find the entry in the DOM and scrolls to it.
 * If the entry is not found, it navigates to the link's URL.
 *
 * @param {Event} event
 */
const liveEntryLinkClick = (event) => {
  event.preventDefault();
  const href = event.target.getAttribute('href');

  const id = new URLSearchParams(href).get('live-feed-entry-id');

  const element = document.getElementById(`live-feed-entry-id-${id}`);

  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
    window.history.pushState({}, '', href);

    return;
  }

  window.location.href = href;
};

domReady(() => {
  document.querySelectorAll('.mediapress-live-entry-link').forEach((link) => {
    link.addEventListener('click', liveEntryLinkClick);
  });
});
